<template>
  <t-dialog
    class="baseDialog"
    dialog-style="padding:0"
    :visible="visible"
    :header="header"
    :width="595"
    v-bind="tConfig"
    @close="visible = false"
  >
    <div :class="isSecurity ? 'h-400' : 'h-504'">
      <slot name="content">{{ content }}</slot>
    </div>
    <template #header>
      <div class="w-full">{{ header }}</div>
    </template>
    <template #footer>
      <div class="text-center">
        <t-button class="w-120" @click="click">我已知悉并同意</t-button>
      </div>
    </template>
  </t-dialog>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    header?: string;
    content?: string;
    isSecurity?: boolean;
    tConfig?: Recordable;
  }>(),
  {
    header: '阅读并同意',
  },
);
const emits = defineEmits(['done']);

const visible = defineModel<boolean>();

const click = () => {
  emits('done');
};
</script>
<style scoped lang="less" src="./css/index.less"></style>
